var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),text = locals_.text;
var jade_indent = [];
buf.push("\n<tr>\n  <td colspan=\"1000\"><span style=\"font-family: monospace; font-style: italic; color: #999\">" + (jade.escape((jade_interp = text) == null ? '' : jade_interp)) + "</span></td>\n</tr>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}